import { render, staticRenderFns } from "./JoinSkewIcon.vue?vue&type=template&id=a5e686f6&"
import script from "./JoinSkewIcon.vue?vue&type=script&lang=js&"
export * from "./JoinSkewIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports